<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ data.title }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="externalEntitiesForm">
        <div class="row m-t-30">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.NAME' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.NAME' | translate }}" formControlName="name" maxlength="50"
                        required>
                    <mat-error *ngIf="externalEntitiesForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="externalEntitiesForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.PHONE_LABEL' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.PHONE_LABEL' | translate }}" formControlName="phone"
                        pattern="^[1-9]\d{9}$" maxlength="10" appAllowOnlyDigits>
                    <mat-error *ngIf="externalEntitiesForm.get('phone')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM10' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
                    <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}</mat-label>
                    <textarea matInput rows="2" formControlName="address" maxlength="500"></textarea>
                    <mat-error *ngIf="externalEntitiesForm.get('address')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM500' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-20">
            <div class="col-lg-9"></div>
            <div class="col-lg-3" style="display: flex; justify-content: flex-end;">
                <button mat-stroked-button (click)="OnCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate
                    }}</button>

                <button mat-flat-button color="warn" class="m-l-4" (click)="onSaveExternalEntities()"
                    [disabled]="externalEntitiesForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>